
import * as React from "react";

import {useSelector} from "react-redux";
import {useRouteMatch} from "react-router-dom";
import styled from "styled-components";

import {selectAddedEntries} from "../../Store/DictionaryState";
import {MediaBreakpoints} from "../../Styles";
import {GTMDataLayerPush} from "../../Util/GoogleTagManager";
import {AppMenuItem} from "../AppMenu/AppMenuItem";

const MobileNav = styled.div`
  display: flex;
  position: fixed;
  margin-top: 15px;
  right: 48px;
  gap: 8px;
    
  @media ${MediaBreakpoints.medium} {
    display: none;
  }
    
  .launcher__link {
    width: 40px;
  }
`;

export const MobileNavigation = () => {
    const isHomeRoute = useRouteMatch({exact: true, path: "/"});
    const addedEntries = useSelector(selectAddedEntries);
    const isDictionaryRoute = useRouteMatch({exact: true, path: "/dictionary"});
    const isSettingsRoute = useRouteMatch({exact: true, path: "/settings"});

    return(
        <MobileNav>
                <AppMenuItem
                    isActive={!!isHomeRoute}
                    iconPath="/assets/icons/appmenu/spellcheck.svg"
                    href="/"
                    type="spellcheck"
                    onClick={() => GTMDataLayerPush({event: "app-menu", option: "spellcheck"})}
                />
                <AppMenuItem
                    indicator={addedEntries}
                    isActive={!!isDictionaryRoute}
                    href="/dictionary"
                    iconPath="/assets/icons/appmenu/dictionary.svg"
                    type="dictionary"
                />
                <AppMenuItem
                    isActive={!!isSettingsRoute}
                    href="/settings"
                    iconPath="/assets/icons/appmenu/settings.svg"
                    type="dictionary"
                />
        </MobileNav>
    )
}